// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3bcxO","col":"styles_col__1871U","fulfillmentStatus":"styles_fulfillmentStatus__2wym9","emailCol":"styles_emailCol__QdFq6"};